import { render, staticRenderFns } from "./PreviewTemplate.vue?vue&type=template&id=237461c7"
import script from "./PreviewTemplate.vue?vue&type=script&lang=js"
export * from "./PreviewTemplate.vue?vue&type=script&lang=js"
import style0 from "./PreviewTemplate.vue?vue&type=style&index=0&id=237461c7&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237461c7')) {
      api.createRecord('237461c7', component.options)
    } else {
      api.reload('237461c7', component.options)
    }
    module.hot.accept("./PreviewTemplate.vue?vue&type=template&id=237461c7", function () {
      api.rerender('237461c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/layout-preview/PreviewTemplate.vue"
export default component.exports